import { BRIDGE_MESSAGE_SOURCES } from "@bezoned/desktop-bridge/bridge-common.js";
import { isBridgeMessageTargetForFrontend } from "@bezoned/desktop-bridge/bridge-predicates.js";
import type { JsonMessagePayload } from "@bezoned/desktop-bridge/events.js";
import {
  isTableCallBridgeMessage,
  TABLE_CALL_MESSAGE_TYPES,
} from "@bezoned/desktop-bridge/table-call-messaging.js";
import type {
  TableCallBridgeMessage,
  TableCallMicrophoneToggleRequestPayload,
} from "@bezoned/desktop-bridge/table-call-messaging.js";

import { logTableCallBridgeMessage } from "./debug-log.js";

const getInboundDesktopTableCallMessage = ({
  bridgeRoom,
  payload,
}: {
  bridgeRoom: string;
  payload: JsonMessagePayload;
}): TableCallBridgeMessage | null => {
  if (payload.room !== bridgeRoom) {
    return null;
  }

  if (!isTableCallBridgeMessage(payload.data)) {
    return null;
  }

  if (payload.data.source !== BRIDGE_MESSAGE_SOURCES.DESKTOP) {
    return null;
  }

  if (!isBridgeMessageTargetForFrontend(payload.data.target)) {
    return null;
  }

  return payload.data;
};

export const createInboundRequestHandler =
  ({
    bridgeRoom,
    onStateRequest,
    onMicrophoneToggleRequest,
    onPttPressed,
    onPttReleased,
  }: {
    bridgeRoom: string;
    onStateRequest: () => void;
    onMicrophoneToggleRequest: (
      payload: TableCallMicrophoneToggleRequestPayload
    ) => void;
    onPttPressed: () => void;
    onPttReleased: () => void;
  }) =>
  (payload: JsonMessagePayload) => {
    const message = getInboundDesktopTableCallMessage({
      bridgeRoom,
      payload,
    });
    if (!message) {
      return;
    }

    logTableCallBridgeMessage({
      direction: "inbound",
      message,
      room: bridgeRoom,
    });

    switch (message.type) {
      case TABLE_CALL_MESSAGE_TYPES.STATE_REQUEST: {
        onStateRequest();
        return;
      }
      case TABLE_CALL_MESSAGE_TYPES.MICROPHONE_TOGGLE_REQUEST: {
        onMicrophoneToggleRequest(message.payload);
        return;
      }
      case TABLE_CALL_MESSAGE_TYPES.PTT_PRESSED: {
        onPttPressed();
        return;
      }
      case TABLE_CALL_MESSAGE_TYPES.PTT_RELEASED: {
        onPttReleased();
        return;
      }
      default: {
        return;
      }
    }
  };
